import React, { useEffect, useState } from "react"
import { Box, Grid, Typography } from "src/UILibrary"
import { FavoriteVideoItem } from "./FavoriteVideoItem"
import { useMediaQuery } from "react-responsive"
import { useRecoilState } from "recoil"
import { RESPONSE_CODE, SNACKBAR_TYPES } from "src/modules/const"
import { ShowToast } from "src/states/showToast"
import { Event, ListFavorite, FavoriteService, EventService } from "src/openapi"
import { useTranslation } from "react-i18next"
import { useLoginContext } from "src/hooks/useLoginContext"
import { EventJoinModal } from "src/pages/event/components/EventJoinModal"
import { Pagination } from "@mui/material"
import { ShowProgress } from "src/states/showProgress"

const PAGE_SIZE = 12

export const FavoriteVideoPageItem = () => {
  const { t } = useTranslation("translation", { keyPrefix: "mypage.favorite_video" })
  const { checkLoginStatus, accessToken, initialized } = useLoginContext()
  const [, setShowToast] = useRecoilState(ShowToast)

  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })

  const [, setShowProgress] = useRecoilState(ShowProgress)

  const [favorites, setFavorites] = useState<ListFavorite[]>([])
  const [pageNum, setPageNum] = useState<number>(1)
  const [total, setTotal] = useState<number>(0)

  const [openJoinModal, setOpenJoinModal] = useState<boolean>(false)
  const [selectedItem, setSelectedItem] = useState<Event>()

  const handleGetFavorites = () => {
    setShowProgress(true)
    FavoriteService.favoriteList(accessToken, (pageNum - 1) * PAGE_SIZE, PAGE_SIZE)
      .then((res) => {
        setShowProgress(false)
        if (!checkLoginStatus(res)) {
          return
        }

        if (res.status === RESPONSE_CODE.SUCCESS) {
          setFavorites(res.data?.favorites as ListFavorite[])
          setTotal(res.data?.count as number)
        } else {
          setShowToast({ show: true, text: t("failed_list"), type: SNACKBAR_TYPES.ERROR })
        }
      })
      .catch(() => {
        setShowProgress(false)
        setShowToast({ show: true, text: t("failed_list"), type: SNACKBAR_TYPES.ERROR })
      })
  }

  const handleItemSelected = (eventId: number) => {
    setShowProgress(true)
    EventService.getEventDetails(eventId, accessToken)
      .then((res) => {
        setShowProgress(false)
        if (!checkLoginStatus(res)) {
          return
        }

        if (res.status === RESPONSE_CODE.SUCCESS) {
          setSelectedItem(res.data)
          setOpenJoinModal(true)
        } else {
          setShowToast({ show: true, text: t("failed_list"), type: SNACKBAR_TYPES.ERROR })
        }
      })
      .catch(() => {
        setShowProgress(false)
        setShowToast({ show: true, text: t("failed_list"), type: SNACKBAR_TYPES.ERROR })
      })
  }

  const sliceItem = (favoriteId: number) => {
    favorites.map((favorite, index) => {
      if (favorite.id == favoriteId) {
        favorites.splice(index, 1)
      }
    })
  }

  const handleItemCanceled = (favoriteId: number) => {
    FavoriteService.deleteFavorite(accessToken, favoriteId)
      .then((res) => {
        if (!checkLoginStatus(res)) {
          return
        }

        if (res.status === RESPONSE_CODE.SUCCESS) {
          setShowToast({
            show: true,
            text: t("success_unfavorite"),
            type: SNACKBAR_TYPES.SUCCESS,
          })
          sliceItem(favoriteId)
        } else {
          setShowToast({ show: true, text: t("failed_unfavorite"), type: SNACKBAR_TYPES.ERROR })
        }
      })
      .catch(() => {
        setShowToast({ show: true, text: t("failed_unfavorite"), type: SNACKBAR_TYPES.ERROR })
      })
  }

  useEffect(() => {
    if (!initialized) {
      return
    }
    handleGetFavorites()
  }, [initialized, pageNum])

  return (
    <>
      <Box
        width="100%"
        sx={{
          display: "flex",
          flexDirection: "column",
          ...(isTablet ? { height: "auto" } : { position: "absolute", top: 60, bottom: 60 }),
          overflowY: "scroll",
        }}
      >
        {favorites.length == 0 ? (
          <Box sx={{ display: "flex", my: "50px", width: "100%" }}>
            <Typography.SubTitleNormal
              sx={{ mx: "auto", fontFamily: "Noto Sans JP !important", color: "gray" }}
            >
              {t("no_data")}
            </Typography.SubTitleNormal>
          </Box>
        ) : (
          <>
            <Grid
              container
              sx={{
                mt: isTablet ? "0px" : "0px",
                borderBottom: "1px dotted #D4D3D7",
              }}
            >
              {favorites.map((favorite) => (
                <>
                  <FavoriteVideoItem
                    key={favorite.id}
                    item={favorite}
                    handleSelected={handleItemSelected}
                    handleCanceled={handleItemCanceled}
                  />
                </>
              ))}
            </Grid>

            <Box display="flex" sx={{ my: "20px", width: "100%" }}>
              <Pagination
                count={Math.ceil(total / PAGE_SIZE)}
                variant="outlined"
                color="primary"
                onChange={(event, page) => setPageNum(page)}
                sx={{ mx: "auto" }}
              />
            </Box>
          </>
        )}
      </Box>
      <EventJoinModal open={openJoinModal} handleOpen={setOpenJoinModal} item={selectedItem} />
    </>
  )
}
